import { isAllowedProtocol, parseChangeUrl } from './parseChangeUrl';

// Exact hosts, not wildcards
const SHORT_LINK_HOSTS = new Set(['c.org', 'www.c.org', 'chng.it', 'www.chng.it', 'staging.chng.it']);

/**
 * Whether `url` is on a Change short-link host. Short links are redirectors themselves, so they're
 * fine to show as a link but are not a valid automatic redirect target.
 *
 * `baseUrl` must be a Change app host or this returns `false`. Never throws.
 */
export function isChangeShortUrl(url: string, { baseUrl }: { baseUrl: string }): boolean {
	const parsed = parseChangeUrl(url, baseUrl);
	return (
		!!parsed && isAllowedProtocol(parsed.parsedUrl, parsed.parsedBaseUrl) && SHORT_LINK_HOSTS.has(parsed.parsedUrl.host)
	);
}
